import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Modal } from '@linktivity/link-ui';
import styles from './autoLogoutDialog.module.css';

interface IAutoLogoutDialogProps {
  visible: boolean;
  remainingSeconds: number;
  onContinue: () => void;
  onLogout: () => void;
}

const AutoLogoutDialog: React.FC<IAutoLogoutDialogProps> = ({
  visible,
  remainingSeconds,
  onContinue,
  onLogout
}) => {
  const { t } = useTranslation();

  const minutes = Math.floor(remainingSeconds / 60)
    .toString()
    .padStart(2, '0');
  const seconds = (remainingSeconds % 60).toString().padStart(2, '0');

  return (
    <Modal
      visible={visible}
      title={t('share.autoLogout.title')}
      onClose={onContinue}
      footer={
        <div className={styles.footer}>
          <Button variant="outlined" onClick={onLogout}>
            {t('share.autoLogout.logout')}
          </Button>
          <Button variant="filled" onClick={onContinue}>
            {t('share.autoLogout.continue')}
          </Button>
        </div>
      }
    >
      <div className={styles.body}>
        <div className={styles.description}>
          {t('share.autoLogout.description1')}
        </div>
        <div className={styles.description}>
          {t('share.autoLogout.description2')}
        </div>
        <p className={styles.countdown}>
          {minutes}:{seconds}
        </p>
      </div>
    </Modal>
  );
};

export default AutoLogoutDialog;
